import { F_MapMarkerIndoorStandFragment } from '__generated__v2/graphql';
import { useCtxMapView } from 'pages/special/OsloDesignFair/map/CtxMapView';
import {
    GlobalLayerIds,
    GlobalSourceIds
} from 'pages/special/OsloDesignFair/map/mapContent/Markers/constants';
import {
    getFeature_IndoorStandMarkerWallInner,
    getFeature_IndoorStandMarkerWallOuter
} from 'pages/special/OsloDesignFair/map/mapContent/Markers/IndoorStandMarkers/getFeatures';
import { Layer, Source } from 'react-map-gl';

interface Props {
    markers: F_MapMarkerIndoorStandFragment[];
}

export const IndoorStandMarkersWall = (props: Props) => {
    const ctxMapView = useCtxMapView();

    const features_Inner = props.markers
        .filter((e) => e.showStructure)
        .filter((e) => e.hasInteractivity)
        .filter((e) => e.selectable)
        .map(getFeature_IndoorStandMarkerWallInner);

    const features_Outer = props.markers
        .filter((e) => e.showStructure)
        .map((e) => getFeature_IndoorStandMarkerWallOuter(e, ctxMapView.highlightedMarkerIds));

    return (
        <>
            <Source
                id={GlobalSourceIds.IndoorStandWalls_Inner}
                type="geojson"
                data={{
                    type: 'FeatureCollection',
                    features: features_Inner
                }}
            >
                <Layer
                    id={GlobalLayerIds.IndoorStandWalls_Inner}
                    type="fill-extrusion"
                    source={GlobalSourceIds.IndoorStandWalls_Inner}
                    paint={{
                        'fill-extrusion-color': ['get', 'color'],
                        'fill-extrusion-height': ['get', 'height'],
                        'fill-extrusion-base': ['get', 'base_height'],
                        'fill-extrusion-opacity': 1
                        // 'fill-extrusion-cast-shadows': false
                    }}
                    layout={{
                        visibility: 'visible'
                    }}
                />
            </Source>
            <Source
                id={GlobalSourceIds.IndoorStandWalls_Outer}
                type="geojson"
                data={{
                    type: 'FeatureCollection',
                    features: features_Outer
                }}
            >
                <Layer
                    id={GlobalLayerIds.IndoorStandWalls_Outer}
                    type="fill-extrusion"
                    source={GlobalSourceIds.IndoorStandWalls_Outer}
                    paint={{
                        'fill-extrusion-color': ['get', 'color'],
                        'fill-extrusion-height': ['get', 'height'],
                        'fill-extrusion-base': ['get', 'base_height'],
                        'fill-extrusion-opacity': 1
                        // 'fill-extrusion-cast-shadows': false
                    }}
                    layout={{
                        visibility: 'visible'
                    }}
                />
            </Source>
        </>
    );
};
